import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: '대시보드',
    link: '/dashboard',
    icon: 'bxs-dashboard',
  },

  {
    id: 2,
    label: '회원 관리',
    icon: 'bx-user',
    subItems: [
      {
        id: 3,
        label: '회원 정보 관리',
        link: 'user',
        parentId: 2,
      },
      {
        id: 4,
        label: '회원 신고 관리',
        link: 'report',
        parentId: 2,
      },
    ],
  },

  {
    id: 5,
    label: '게시물 관리',
    icon: 'bx bx-file',
    subItems: [
      {
        id: 6,
        label: '게시물 정보 관리',
        link: 'post-info',
        parentId: 5,
      },
      {
        id: 7,
        label: '게시물 신고 관리',
        link: 'post-report',
        parentId: 5,
      },
    ],
  },

  {
    id: 8,
    label: '회사 정보 관리',
    icon: 'bx bx-collection',
    subItems: [
      {
        id: 9,
        label: '이메일 도메인 관리',
        link: 'email-domain',
        parentId: 8,
      },
      {
        id: 10,
        label: '회사 태그 관리',
        link: 'company-tag',
        parentId: 8,
      },
    ],
  },

  {
    id: 11,
    label: '회사 인증 관리',
    icon: 'bxs-news',
    subItems: [
      {
        id: 12,
        label: '전직 인증 관리',
        link: 'previous-job',
        parentId: 11,
      },
      {
        id: 13,
        label: '현직 인증 관리',
        link: 'now-job',
        parentId: 11,
      },
    ],
  },

  {
    id: 14,
    label: '서비스 / 정보 관리',
    icon: 'bx-info-circle',
    subItems: [
      {
        id: 15,
        label: '1:1 문의 관리',
        link: 'inquiry-manage',
        parentId: 14,
      },
      {
        id: 16,
        label: '공지사항',
        link: 'notices',
        parentId: 14,
      },
      {
        id: 17,
        label: '이용약관 / 개인정보처리방침',
        link: 'term',
        parentId: 14,
      },
    ],
  },
];
